// extracted by mini-css-extract-plugin
export var customFont = "Header-module--customFont--2ac4d";
export var item = "Header-module--item--91b6d";
export var list = "Header-module--list--c8404";
export var logo = "Header-module--logo--33d11";
export var mobileNavbar = "Header-module--mobileNavbar--7c05a";
export var root = "Header-module--root--bfdde";